// THEWOOMAIN script
const THEWOOGINSENG = (() => {

    // SELECTOR
    const SELECTOR = {
        kv: '.ginseng-kv',
        kvText: '.ginseng-kv__content',
        kvObject: '.ginseng-kv__object',

        years: '.ginseng-years__content',
        yearsContent: '.ginseng-years__sticky',
        yearsObject: '.ginseng-years__object',
        yearsText1: '.ginseng-years__desc--top',
        yearsText2: '.ginseng-years__desc--bottom',

        fadeEffect: '.is-hidden-default, .is-hidden-up'
    }

    // KvFrame
    const kvFrame = (() => {
        const saveStyle = () => [`${SELECTOR.kvObject}, ${SELECTOR.kvText}`];

        const setup = () => gsap.timeline({
            scrollTrigger: {
                trigger: SELECTOR.kv,
                start: 'top top',
                end: '+=1000',
                scrub: true,
                ease: 'none',
                pin: true,
                invalidateOnRefresh: true
                // markers: true,
            }
        })
        .to(
            SELECTOR.kvObject, 
            { opacity: 0.3 }
        )
        .to(
            SELECTOR.kvText, 
            { opacity: 1 },
            0.2
        );

        return {saveStyle, setup};
    })();

    // years
    const yearsFrame = (() => {
        const saveStyle = () => [`${SELECTOR.yearsObject}, ${SELECTOR.yearsText1}, ${SELECTOR.yearsText2}, ${SELECTOR.yearsObject} img`];

        const PC = () => {

            gsap.fromTo(SELECTOR.yearsObject, 
                { 
                    scale: 0.5
                },
                {
                scale: 1,
                ease: 'none',
                scrollTrigger: {
                    trigger: SELECTOR.yearsContent,
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: true,
                    // markers: true
                }
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: SELECTOR.years,
                    start: 'top top-=25%',
                    end: 'bottom bottom+=25%',
                    scrub: true,
                    ease: 'none',
                    invalidateOnRefresh: true,
                    // markers: true,
                }
            })
            .fromTo(SELECTOR.yearsText1, 
                { 
                    opacity: 0,
                    y: '-20px' 
                },
                { 
                    opacity: 1,
                    y: '0'
                }
            )
            .fromTo(SELECTOR.yearsText2, 
                { 
                    opacity: 0,
                    y: '-20px' 
                },
                { 
                    opacity: 1,
                    y: '0'
                }
            )
    
        }

        const MO = () => {
            new setParallax(SELECTOR.yearsObject, `${SELECTOR.yearsObject} img`);
        }

        return { saveStyle, PC, MO };
    })();

    // fadeEffect
    // const fadeEffect = (() => {
    //     const setup = () => ScrollTrigger.batch(SELECTOR.fadeEffect, {
    //         start: 'top 90%',
    //         // markers: true,
    //         invalidateOnRefresh: true,
    //         onEnter: (batch) => {
    //             // ScrollTrigger.refresh();
    //             batch.forEach(item => {
    //                 item.classList.add('is-visible');
    //             });
    //         },
    //         onLeaveBack: (batch) => {
    //             // ScrollTrigger.refresh();
    //             batch.forEach(item => {
    //                 item.classList.remove('is-visible');
    //             });
    //         }
    //     });

    //     return { setup };
    // })();

    // saveStyle
    const saveStyles = () => {
        const allStyles = [
            ...kvFrame.saveStyle(),
            ...yearsFrame.saveStyle()
        ];
        ScrollTrigger.saveStyles(allStyles);
    }


    const init = () => {
        
        gsap.registerPlugin(ScrollTrigger);

        // savestyle
        saveStyles();

        ScrollTrigger.matchMedia({

            // all
            all: () => {

                // kv
                kvFrame.setup();

                // fadeEffect
                // fadeEffect.setup();

                // history parallax
                const history = new setParallax('.ginseng-history__object', '.ginseng-history__object img');

                // grid parallax
                const grid1 = new setParallax('.ginseng-effect__grid .grid-parallax-1', '.ginseng-effect__grid .grid-parallax-1 img', '-10%', '10%');
                const grid2 = new setParallax('.ginseng-effect__grid .grid-parallax-2', '.ginseng-effect__grid .grid-parallax-2 img', '-10%', '10%');

            },


            // mobile
            '(max-width: 750px)': () => {

                // years mobile parallax
                yearsFrame.MO();

                // ginseng parallax MO
                const ginseng1 = new setParallax('.ginseng-about__grid1 .about-object1 ', '.about-object1 img', '-15%', '15%');
                const ginseng2 = new setParallax('.ginseng-about__grid1 .about-object2 ', '.about-object2 img', '-8%', '8%');
                const ginseng3 = new setParallax('.ginseng-about__grid2 .about-object3 ', '.about-object3 img', '-10%', '10%');
                const ginseng4 = new setParallax('.ginseng-about__grid2 .about-object4 ', '.about-object4 img', '-10%', '10%');

            },

            // pc
            '(min-width: 751px)': () => {

                // years
                yearsFrame.PC();
                
                // ginseng parallax PC
                const ginseng1 = new setParallax('.ginseng-about__grid1 .about-object1 ', '.about-object1 img', '-15%', '15%');
                const ginseng2 = new setParallax('.ginseng-about__grid1 .about-object2 ', '.about-object2 img', '-25%', '25%');
                const ginseng3 = new setParallax('.ginseng-about__grid2 .about-object3 ', '.about-object3 img', '-15%', '5%');
                const ginseng4 = new setParallax('.ginseng-about__grid2 .about-object4 ', '.about-object4 img', '-15%', '15%');

            }

        });

    }

    return {
        init: () => {
            init();
        }
    }

})();

document.addEventListener("DOMContentLoaded", function () {

    THEWOOGINSENG.init();

});
